export default "__VITE_ASSET__C6ZE1oT7__"